import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import Layout from 'src/components/Layout/index'
import Hero from 'src/components/Hero/index'
import IntroSection from 'src/components/Home/IntroSection'
import Benefits from 'src/components/Benefits'
import Register from 'src/components/Register'

import * as style from './index-style.module.css'

export function IndexPageTemplate({
  hero,
  introHeading,
  introItems,
  benefits,
  register,
}) {
  return (
    <>
      <Hero
        className={style.home_hero}
        heading={hero?.heading}
        subheading={hero?.subheading}
        video={hero?.video}
        image={hero?.image}
        cta={hero?.cta}
      />
      <IntroSection
        title={introHeading}
        items={introItems}
      />
      <Benefits large four benefits={benefits} />
      <Register
        title={register?.title}
        cta={register?.href}
      />
    </>
  )
}

export default function IndexPage({ data }) {
  const {
    markdownRemark: {
      frontmatter: {
        hero,
        intro_heading,
        intro_items,
        benefits,
        register,
      },
    },
  } = data

  return (
    <Layout fullWidth>
      <IndexPageTemplate
        hero={hero}
        introHeading={intro_heading}
        introItems={intro_items}
        benefits={benefits}
        register={register}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
    allMarkdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export const pageQuery = graphql`
  query IndexPageQuery {
    markdownRemark(
      frontmatter: { templateKey: { eq: "index-page" } }
    ) {
      frontmatter {
        title
        hero {
          heading
          subheading
          video {
            publicURL
          }
          image {
            childImageSharp {
              fluid(maxWidth: 480) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
          cta {
            text
            href
          }
        }
        intro_heading
        intro_items {
          image {
            childImageSharp {
              fluid(maxWidth: 306) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
          title
          description
          cta {
            text
            href
          }
        }
        benefits {
          title
          image {
            publicURL
          }
          description
        }
        register {
          title
          cta {
            text
            href
          }
        }
      }
    }
  }
`
